import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';



export default function DGLTH_customer_offer({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()
    const userInfo = LoginManager.getUserInfo();

    function previewCustomerOffer(item) {
        navigate('/page/CustomerOfferPreview?id=' + item.id)
    }

    async function customerOfferConvertInOrder() {
        var userInfo = LoginManager.getUserInfo();
        console.warn('item', item)
        Swal.fire({ title: 'Attendere', text: 'Conversione preventivo...', allowOutsideClick: false, didOpen: () => { Swal.showLoading() } })

        if (item.status && item.status.value === "10_CONFIRMED") {
            Swal.fire({ title: 'Errore', text: 'Questo preventivo è già stato convertito in ordine.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
        else {
            var body = {
                status: { value: '10_CONFIRMED' }
            }
            var response = await DataManager.updateItem('customer_offer', body, item.id)
            console.warn(response)
            if (response.success === 1) {
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraints = [{ "fieldName": "levelUser", type: "value", value: 1 }]
                var resNotifiche = await DataManager.searchItems('gyv_notification', 1, 50, sorting, '', [], constraints);
                console.log(resNotifiche);
                if (resNotifiche.success === 1 && resNotifiche.body.length > 0) {
                    for (let i = 0; i < resNotifiche.body.length; i++) {
                        if (resNotifiche.body[i].notificationAll === 1 && resNotifiche.body[i].notificationOffer === 1) {
                            var bodyEmail = {
                                emailTo: resNotifiche.body[i].emailUser,
                                riferimento: item.internalCode,
                                idOrder: item.id,
                                entity: 'offer',
                                stato: 'CONVERTITO IN ORDINE'
                            }
                            var responseEmail = await ApiManager.sendAuthenticatedRequest('/custom/send_mail_change_status', bodyEmail);
                            console.warn(responseEmail);
                        }
                    }
                }

                var sortingOffer = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraintsOffer = [{ "fieldName": "id", type: "value", value: item.id }]
                var resultOffer = await DataManager.searchItems('customer_offer', 1, 50, sortingOffer, '', [], constraintsOffer);
                if (resultOffer.success === 1) {

                    console.log(resultOffer);
                    Swal.fire({ title: 'Completato', text: 'Preventivo confermato. Compila l\'ordine con i campi mancanti. RICORDATI DI SALVARE L\'ORDINE.', icon: 'success', confirmButtonColor: '#198754' })
                    navigate('/entity/customer_order/add', {
                        state: {
                            body: {
                                idCustomerOffer: { id: item.id },
                                idCustomer: resultOffer.body[0].idCustomer,
                                idSalesAgent: resultOffer.body[0].idSalesAgent,
                                discount: resultOffer.body[0].discount,
                                notes: resultOffer.body[0].notes,
                                rows: (resultOffer.body[0].rows || []).map(row => ({
                                    ...row,
                                    discountOrder: row.discountOffer || '0',
                                })),
                                files: resultOffer.body[0].files,
                                riferimento: resultOffer.body[0].riferimento,
                                status: { value: '0_PENDING' },
                                vat: resultOffer.body[0].vat,
                                idVatCondition: resultOffer.body[0].idVatCondition ? { id: resultOffer.body[0].idVatCondition.id, name: resultOffer.body[0].idVatCondition.name } : null,
                                idPaymentCondition: resultOffer.body[0].idPaymentCondition ? { id: resultOffer.body[0].idPaymentCondition.id, name: resultOffer.body[0].idPaymentCondition.name } : null,
                                parking: resultOffer.body[0].parking,
                                parquet: resultOffer.body[0].parquet,
                                pedestrian_zone: resultOffer.body[0].pedestrian_zone,
                                hoist_elevator: resultOffer.body[0].hoist_elevator,
                                floor: resultOffer.body[0].floor,
                                no_traffic_zone: resultOffer.body[0].no_traffic_zone,
                                building: resultOffer.body[0].building,
                                zone: resultOffer.body[0].zone,
                                ladder_truck: resultOffer.body[0].ladder_truck,
                                elevator: resultOffer.body[0].elevator,
                                increase: resultOffer.body[0].increase,
                                discount: resultOffer.body[0].discount,
                                transportCost: resultOffer.body[0].transportCost,
                                deliveryDate: resultOffer.body[0].deliveryDate,
                                deliveryAddress: resultOffer.body[0].deliveryAddress,
                                locality: resultOffer.body[0].locality,
                            }
                        }
                    })

                }


                console.log(body);
            }
            else {
                if (response.message && response.message != '') {
                    Swal.fire({ title: 'Errore', text: response.message, icon: 'error', confirmButtonColor: '#dc3545' })
                }
                else {
                    Swal.fire({ title: 'Errore', text: 'Non è stato possibile convertire questo preventivo.', icon: 'error', confirmButtonColor: '#dc3545' })
                }
            }
        }
    }


    async function revert() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [{ "fieldName": "idCustomerOffer", type: "value", value: item.id }]
        var result = await DataManager.searchItems('customer_order', 1, 50, sorting, '', [], constraints);
        if (result.success === 1) {
            if (result.body.length > 0) {
                Swal.fire({ title: 'Errore', text: 'Impossibile fare il revert in quanto è già presente un ordine creato da questo preventivo', icon: 'error', confirmButtonColor: '#dc3545' })
            } else {
                var data = {
                    status: { value: '0_PENDING' }
                }
                var update = await DataManager.updateItem('customer_offer', data, item.id);
                if (update.success === 1) {
                    Swal.fire({ title: 'Completato', text: 'Revert eseguito con successo!', icon: 'success', confirmButtonColor: '#198754' })
                    refreshData()
                }
            }
        }

    }

    async function declined() {
        var update = await DataManager.updateItem('customer_offer', { status: { value: "20_DECLINED" } }, item.id)
        if (update.success === 1) {
            Swal.fire({ title: 'Completato', text: 'Preventivo rifiutato con successo!', icon: 'success', confirmButtonColor: '#198754' })
            closeModalDelete()
            refreshData()
        } else {
            Swal.fire({ title: 'Errore', text: update.message, icon: 'error', confirmButtonColor: '#dc3545' })
            closeModalDelete()
        }
    }


    const [statusModalCheckOffer, setStatusModalCheckOffer] = useState(false)
    function closeModalCheckOffer() {
        setStatusModalCheckOffer(false)
    }
    function openModalCheckOffer(id) {
        setStatusModalCheckOffer(true)
    }

    const [totConfirmOffer, setTotConfirmOffer] = useState(null)
    const [totRowsOffer, setTotRowsOffer] = useState(null)
    const [aboluteMargin, setAbsoluteMargin] = useState(null)
    const [margin, setMargin] = useState(null)
    async function checkPriceOffer() {
        openModalCheckOffer()
        var res = await DataManager.getItem('customer_offer', item.id);
        console.log(res)
        if (res.success === 1) {
            var co = res.body[0]
            var a = co.rows.reduce((a, c) => a + (parseFloat(c.listPrice) * parseFloat(c.quantity)), 0);
            const b = co.rows.reduce((sum, c) => {
                const price = parseFloat(c.listPrice) || 0;
                const qty = parseFloat(c.quantity) || 0;

                // Costruiamo il moltiplicatore partendo da 1
                let multiplier = 1;

                // Se commercial è diverso da "0" e non è vuoto, lo applichiamo
                if (
                    c.idSupplier.commercial_discount !== "0" &&
                    c.idSupplier.commercial_discount !== ""
                ) {
                    multiplier *= (parseFloat(c.idSupplier.commercial_discount) || 0) / 100;
                }

                console.log(multiplier)
                // Se cash_flow_discount è diverso da "0" e non è vuoto, lo applichiamo
                if (
                    c.idSupplier.cash_flow_discount !== "0" &&
                    c.idSupplier.cash_flow_discount !== ""
                ) {
                    multiplier *= (1 - (parseFloat(c.idSupplier.cash_flow_discount) || 0) / 100);
                }
                console.log(multiplier)

                console.log(sum, price, qty, multiplier)
                // Sommiamo il contributo di questa riga
                return sum + price * qty * multiplier;
            }, 0);

            const absoluteMargin = a - b;
            const markupPercentage = ((a - b) / a) * 100;

            console.log(b)
            setTotConfirmOffer(b)
            setTotRowsOffer(a)
            setAbsoluteMargin(absoluteMargin)
            setMargin(markupPercentage)

        }
        openModalCheckOffer()
    }



    const [statusModalDelete, setStatusModalDelete] = useState(false)
    function closeModalDelete() {
        setStatusModalDelete(false)
    }
    function openModalDelete() {
        setStatusModalDelete(true)
    }


    if (entity !== null) {
        return (
            <>
                {(parseInt(userInfo.level) === 0 || parseInt(userInfo.level) === 1) ? <>
                    <Button className='m-1' variant='outline-secondary' size='sm' onClick={() => checkPriceOffer()}>Calcolo margine</Button>
                </> : null}

                {item.status.value === '0_PENDING' || item.status.value === '5_PRESALE' ?
                    <Button className='m-1' variant='outline-success' size='sm' onClick={() => customerOfferConvertInOrder()}>Converti</Button>
                    : <></>}

                {item.status.value === '0_PENDING' ? <>
                    <Button className='m-1' variant='outline-danger' size='sm' onClick={() => openModalDelete()}>Rifiuta</Button>
                </> : null}
                {item.status.value === '10_CONFIRMED' ? <>
                    <Button className='m-1' variant='outline-danger' size='sm' onClick={() => revert()}>Annulla</Button>
                </> : null}
                <Button onClick={() => previewCustomerOffer(item)} size="sm" variant="outline-secondary" className='m-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>


                <Modal show={statusModalCheckOffer} onHide={closeModalCheckOffer} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Margine</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col className='text-center'>
                                <p className='mb-0'>Prezzo di listino articoli</p>
                                <h3>{parseFloat(totRowsOffer).toLocaleString('it-IT', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })} €</h3>
                            </Col>
                            <Col className='text-center'>
                                <p className='mb-0'>Costo stimato articoli</p>
                                <h3>{parseFloat(totConfirmOffer).toLocaleString('it-IT', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })} €</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-center'>
                                <p className='mb-0'>Margine assoluto</p>
                                <h3>{parseFloat(aboluteMargin).toLocaleString('it-IT', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })} €</h3>
                            </Col>
                            <Col className='text-center'>
                                <p className='mb-0'>Margine percentuale</p>
                                <h3>{parseInt(margin)} %</h3>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>



                <Modal show={statusModalDelete} onHide={closeModalDelete}>
                    <Modal.Header closeButton>
                        <Modal.Title>Rifiuta preventivo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col className='text-center'>
                                <p>Sei sicuro di voler rifiutare il preventivo?</p>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='secondary' onClick={() => closeModalDelete()}>No, indietro</Button>
                        <Button variant='danger' onClick={() => declined()}>Si, rifiuta</Button>
                    </Modal.Footer>
                </Modal>



            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
